"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOriginalDocTitle = void 0;
const react_1 = require("react");
const useOriginalDocTitle = () => {
  const originalTitle = (0, react_1.useRef)();
  const hasDocument = typeof document !== "undefined";
  const documentTitle = hasDocument ? document === null || document === void 0 ? void 0 : document.title : undefined;
  // Save a reference to the original document title once
  // the document becomes available (SSR friendly)
  (0, react_1.useEffect)(() => {
    // Abort if:
    // - there is no document,
    // - there is no document title set (yet?),
    // - there has already been a valid (non-empty string) document title set.
    if (!hasDocument || !documentTitle || originalTitle.current) return;
    originalTitle.current = documentTitle;
  }, [hasDocument, documentTitle]);
  return originalTitle.current;
};
exports.useOriginalDocTitle = useOriginalDocTitle;